

























































































































































import { Component, Mixins } from "vue-property-decorator";
import { ICrumb } from "@/components/app-base/UBreadcrumbs.vue";
import TransactionsProvider from "@/components/app/admin/transactions/transactionsProvider.vue";
import PaymentStatusMixin from "@/mixins/paymentStatusMixin";

@Component({
  components: {
    "invoice-provider": () =>
      import("@/components/app/global/invoices/invoiceProvider.vue"),
    "invoice-details": () =>
      import("@/components/app/global/invoices/invoiceDetails.vue"),
    "transactions-listing": () =>
      import("@/components/app/admin/transactions/transactionsListing.vue"),
    "transactions-provider": TransactionsProvider,
    "invoice-payments-list": () =>
      import("@/components/app/global/payments/invoicePaymentsList.vue"),
    "invoice-actions": () =>
      import("@/components/app/global/invoices/invoiceActions.vue"),
    "invoice-status-msg": () =>
      import("@/components/app/global/invoices/invoiceStatusMsg.vue"),
    "invoice-products-inactive-msg": () =>
      import("@/components/app/global/invoices/invoiceProductsInactiveMsg.vue"),
    "invoice-pending-payment-msg": () =>
      import("@/components/app/global/invoices/invoicePendingPaymentMsg.vue"),
    "invoice-duplicate-msg": () =>
      import("@/components/app/global/invoices/invoiceDuplicateMsg.vue"),
    "invoice-duplicated-msg": () =>
      import("@/components/app/global/invoices/invoiceDuplicatedMsg.vue"),
    "timeline-table": () =>
      import("@/components/app/global/timelineComponent/timelineTable.vue"),
    "calculated-commissions-table": () =>
      import("@/components/app/global/affiliate/calculatedCommissionsTable.vue")
  }
})
export default class AdminClientInvoiceView extends Mixins(PaymentStatusMixin) {
  // Refs
  public $refs!: {
    transactionsProvider: TransactionsProvider;
  };
  public invoiceId = this.$route.params.invoiceId;

  public mounted() {
    this.$bus.$emit("scrollToTop");
  }

  // Computed

  public get breadcrumbs(): ICrumb[] {
    return [
      {
        label: this.$t("_.invoices"),
        route: {
          to: {
            name: "adminClientInvoices"
          }
        }
      },
      {
        label: this.$t("_.invoice")
      }
    ];
  }

  public refreshTransactions() {
    this.$refs?.transactionsProvider?.reloadData();
  }

  public getAffiliateCommissions(invoice) {
    return this.$_.orderBy(
      this.$_.get(invoice, "affiliate_commissions", []),
      ["created_at"],
      ["desc"]
    );
  }
}
